module.exports = __webpack_public_path__ + "img/21.109d7b77.png";